import React from "react";
import { Chip } from "@mui/material";

const WellBeingConnect = ({ user }) => {
  const now = Date.now();
  const rawTimestamp = Number(user?.currentTimeStamp || user?.timestamp || user?.lastMovedAt || 0);
  const isRecentTelemetry = rawTimestamp > 0 && (now - rawTimestamp < 60000);
  const isConnected = Boolean(
    user?.socketId ||
    user?.online_status ||
    user?.isOnline ||
    isRecentTelemetry
  );

  const getColor = () => {
    return isConnected ? { color: "#1b5e20", text: "ON" } : { color: "#d50000", text: "OFF" };
  };

  const color = getColor();

  return (
    <Chip
      label={<div style={{ textAlign: "center" }}>{color.text}</div>}
      style={{
        backgroundColor: color.color,
        color: "white",
        borderRadius: "5px",
        fontWeight: "bold",
        height: "auto",
        padding: "5px",
      }}
    />
  );
};

export default React.memo(WellBeingConnect);
